// @noflow
import curryN from 'lodash/fp/curryN';
import { createAction } from 'redux-actions';

export const createCurriedAction = (type, payloadCreator) =>
    curryN(payloadCreator.length, createAction(type, payloadCreator));



// WEBPACK FOOTER //
// ./src/core/state/createCurriedAction.js